var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 22.25L18.7458 18.7458M20.6389 14.1944C20.6389 17.7536 17.7536 20.6389 14.1944 20.6389C10.6353 20.6389 7.75 17.7536 7.75 14.1944C7.75 10.6353 10.6353 7.75 14.1944 7.75C17.7536 7.75 20.6389 10.6353 20.6389 14.1944Z",
    stroke: "#3B1F8E",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.564926f23cd7d415ff7041398aaf00e2.svg";
export { ForwardRef as ReactComponent };